<template>
   <v-layout v-if="socialLinks && socialLinks.length > 0" row align-center :justify="layoutJustify" style="width: 100%; max-width: 300px; margin-top: 5px; flex-wrap: wrap">
    <v-flex xs2 v-for="(link, index) in socialLinks" :key="index">
      <a
        v-if="link.type"
        :class="link.type.toLowerCase()"
        :href="generateShareUrl(link.type, link.url)"
        target="_blank"
      >
        <img class="social-img" :src="getIcon(link.type)"/>
      </a>
    </v-flex>
  </v-layout>
  <v-layout v-else row align-center :justify="layoutJustify" style="width: 100%; max-width: 300px; margin-top: 5px">
    <v-flex xs4>
      <a id="tweetButton" target="_blank" :href="tweetUrl">
        <svg viewBox="0 0 24 24" fill="white" width="16" height="16"><path d="M22.46 6c-.77.35-1.6.58-2.46.69.88-.53 1.56-1.37 1.88-2.38-.83.5-1.75.85-2.72 1.05C18.37 4.5 17.26 4 16 4c-2.35 0-4.27 1.92-4.27 4.29 0 .34.04.67.11.98C8.28 9.09 5.11 7.38 3 4.79c-.37.63-.58 1.37-.58 2.15 0 1.49.75 2.81 1.91 3.56-.71 0-1.37-.2-1.95-.5v.03c0 2.08 1.48 3.82 3.44 4.21a4.22 4.22 0 0 1-1.93.07 4.28 4.28 0 0 0 4 2.98 8.521 8.521 0 0 1-5.33 1.84c-.34 0-.68-.02-1.02-.06C3.44 20.29 5.7 21 8.12 21 16 21 20.33 14.46 20.33 8.79c0-.19 0-.37-.01-.56.84-.6 1.56-1.36 2.14-2.23z"/></svg>
        <span>{{ $vuetify.t('$vuetify.common.tweet') }}</span>
      </a>
    </v-flex>

    <v-flex xs4>
      <a class="whatsapp-old" target="_blank" ref="TwitterLink" :href="`https://api.whatsapp.com/send?text=${ShareString} ${encodeURIComponent(storeUrl)}`">
        <svg viewBox="0 0 24 24" fill="white" width="16" height="16"><path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347m-5.421 7.403h-.004a9.87 9.87 0 0 1-5.031-1.378l-.361-.214-3.741.982.998-3.648-.235-.374a9.86 9.86 0 0 1-1.51-5.26c.001-5.45 4.436-9.884 9.888-9.884 2.64 0 5.122 1.03 6.988 2.898a9.825 9.825 0 0 1 2.893 6.994c-.003 5.45-4.437 9.884-9.885 9.884m8.413-18.297A11.815 11.815 0 0 0 12.05 0C5.495 0 .16 5.335.157 11.892c0 2.096.547 4.142 1.588 5.945L.057 24l6.305-1.654a11.882 11.882 0 0 0 5.683 1.448h.005c6.554 0 11.89-5.335 11.893-11.893a11.821 11.821 0 0 0-3.48-8.413z"/></svg>
        <span>{{ $vuetify.t('$vuetify.common.share') }}</span>
      </a>
    </v-flex>
    <v-flex xs4 v-if="!isMobile">
      <a id="facebookButton" target="_blank" :href="`https://www.facebook.com/sharer/sharer.php?u=${encodeURIComponent(storeUrl)}`">
        <svg viewBox="0 0 24 24" fill="white" width="16" height="16"><path d="M24 12.073c0-6.627-5.373-12-12-12s-12 5.373-12 12c0 5.99 4.388 10.954 10.125 11.854v-8.385H7.078v-3.47h3.047V9.43c0-3.007 1.792-4.669 4.533-4.669 1.312 0 2.686.235 2.686.235v2.953H15.83c-1.491 0-1.956.925-1.956 1.874v2.25h3.328l-.532 3.47h-2.796v8.385C19.612 23.027 24 18.062 24 12.073z"/></svg>
        <span>{{ $vuetify.t('$vuetify.common.share') }}</span>
      </a>
    </v-flex>
  </v-layout>
</template>

<script>
import { mapGetters } from "vuex";

export default {
  props: {
    referralLink: {
      type: String,
      default: null
    }
  },
  data() {
    return {
      isMobile: window.innerWidth <= 600,
      currentLang: (this.$vuetify && this.$vuetify.lang && this.$vuetify.lang.current) || 'en',
      socialIcons: {
        FACEBOOK: `${process.env.VUE_APP_ASSET_PREFIX}/img/icons/facebook.png`,
        GOOGLE: `${process.env.VUE_APP_ASSET_PREFIX}/img/icons/google.png`,
        TWITTER: `${process.env.VUE_APP_ASSET_PREFIX}/img/icons/twitter.png`,
        WHATSAPP: `${process.env.VUE_APP_ASSET_PREFIX}/img/icons/whatsapp.png`,
        WECHAT: `${process.env.VUE_APP_ASSET_PREFIX}/img/icons/wechat.png`,
        LINKEDIN: `${process.env.VUE_APP_ASSET_PREFIX}/img/icons/linkedin.png`,
        TIKTOK: `${process.env.VUE_APP_ASSET_PREFIX}/img/icons/tiktok.png`,
        YOUTUBE: `${process.env.VUE_APP_ASSET_PREFIX}/img/icons/youtube.png`,
        QQ: `${process.env.VUE_APP_ASSET_PREFIX}/img/icons/qq.png`,
        INSTAGRAM: `${process.env.VUE_APP_ASSET_PREFIX}/img/icons/instagram.png`,
        LITTLE_RED_BOOK: `${process.env.VUE_APP_ASSET_PREFIX}/img/icons/little-red-book.png`
      },
      socialLinks: []
    };
  },
  computed: {
    layoutJustify() {
      const buttonCount = this.socialLinks.length;
      return buttonCount === 2 ? "flex-start" : "space-around";
    },
    tweetUrl() {
      const baseTweetUrl = 'https://twitter.com/intent/tweet?text=';
      const text = this.ShareString;
      const url = this.referralLink ? `You can try it here: ${encodeURIComponent(this.referralLink)}` : '';

      return `${baseTweetUrl}${encodeURIComponent(text)} ${url}`;
    },
    ShareString() {
      return `Enjoyed my meal at ${this.getStore.name}!`
    },
    facebookLocale() {
      const map = { zhHans: 'zh_CN', zhTW: 'zh_TW', fr: 'fr_FR', es: 'es_ES', ar: 'ar_AR', ko: 'ko_KR', th: 'th_TH', vi: 'vi_VN' };
      return map[this.currentLang] || 'en_US';
    },
    storeUrl() {
      return this.referralLink ? this.referralLink : window.location.href;
    },
    ...mapGetters(["getStore"])
  },
  methods: {
    getIcon(type) {
      return this.socialIcons[type] || "";
    },
    generateShareUrl(type, url) {
      return url;
      // const encodedUrl = encodeURIComponent(url);
      // switch (type) {
      //   case "FACEBOOK":
      //     return `https://www.facebook.com/sharer/sharer.php?u=${encodedUrl}`;
      //   case "TWITTER":
      //     return `https://twitter.com/intent/tweet?url=${encodedUrl}`;
      //   case "WHATSAPP":
      //     return `https://api.whatsapp.com/send?text=${encodedUrl}`;
      //   case "LINKEDIN":
      //     return `https://www.linkedin.com/shareArticle?mini=true&url=${encodedUrl}`;
      //   default:
      //     return url;
      // }
    }
  },
  mounted() {
    this.$bus.$on('langChanged', (lang) => { this.currentLang = lang; });
    this.socialLinks = this.getStore && this.getStore.socialMediaLinks ? this.getStore.socialMediaLinks : [];
    // DEV-11345: no longer injects platform.twitter.com/widgets.js -- the share buttons are plain
    // links (widgets.js only upgrades .twitter-share-button), so it only added a download + ad tracking.
  },
  destroyed() {
    this.$bus.$off('langChanged');
  }
};
</script>

<style scoped>
.social-buttons a {
  display: inline-flex; 
  align-items: center;
  justify-content: center;
  text-decoration: none;
  padding: 0;
  border-radius: 5px;
  text-shadow: 0 0 1px rgba(0, 0, 0, 0.2);
}

.social-img {
  margin-right: 0;
  width: 30px; 
  height: auto;
  background: white;
  padding: 2.5px;
  border-radius: 25px;
}
  #tweetButton, .whatsapp-old, #facebookButton {
    width: 72px !important;
    height: 28px;
    border-radius: 5px;
    font-size: 12px;
    color: white !important;
    text-decoration: none !important;
    display: flex;
    align-items: center;
    justify-content: center;
    margin: auto;
    padding: 0;
    box-sizing: border-box;
    gap: 4px;
  }

  #tweetButton {
    background-color: #1DA1F2;
  }

  .whatsapp-old {
    background: #1DC143;
  }

  #facebookButton {
    background-color: #1877F2;
  }

  #tweetButton svg, .whatsapp-old svg, #facebookButton svg {
    flex-shrink: 0;
  }
</style>
